import React from "react";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import APIS from "../../contants/Endpoints";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reuseable/Spinner";
const TransactionDetailsComponent = loadable(
  () => import("../../components/Transaction/TransactionDetails")
);
type Props = {};

const TransactionDetails = (props: Props) => {
  const { id } = useParams();
  const { data: orderDetailsData, isPending: orderDetailsLoading } = useGetHook(
    {
      queryKey: [`order${id}`],
      url: `${APIS.ORDER}${id}/`,
      params: {},
    }
  );
  return (
    <>
      {orderDetailsLoading ? (
        <Spinner />
      ) : (
        <TransactionDetailsComponent orderDetailsData={orderDetailsData} />
      )}
    </>
  );
};

export default TransactionDetails;
